import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import useCookieDismissal from '../../util/hooks/useCookieDismissal';
import { IconButton, Icon } from '../../components';

import css from './Topbar.module.css';

// Closing the notice hides it for two weeks.
const DISMISS_DAYS = 14;

/**
 * "Attractr is currently in private beta." above the top bar. It is in the server's markup, so the
 * page doesn't jump when it appears; visitors who closed it lose it once the page is loaded.
 */
const TopbarNotice = () => {
  const intl = useIntl();
  const [isVisible, dismiss] = useCookieDismissal('topbarNoticeAccepted', DISMISS_DAYS);
  return isVisible ? (
    <div className={css.notice}>
      <span className={css.noticeText}>
        <FormattedMessage id="Topbar.notice" />
      </span>
      <IconButton
        className={css.noticeClose}
        label={intl.formatMessage({ id: 'Modal.closeModal' })}
        onClick={dismiss}
      >
        <Icon name="close" size={16} />
      </IconButton>
    </div>
  ) : null;
};

export default TopbarNotice;
